export default "__VITE_ASSET__45f5fa3c__"